import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import GetAppIcon from '@material-ui/icons/GetApp';
import { DIALOGS } from 'src/models/DialogModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { t } from 'src/lib/language';

interface OwnProps {
  fundraisingId?: number;
}
const DownloadAmbassadorButton = (props: ButtonProps & OwnProps) => {
  const { disabled, fundraisingId } = props;
  const dispatch = useAppDispatch();

  const lang = useSelector((state: Store) => state.language.language);
  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.ambassadorDownload, payload: fundraisingId }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.get_contacts')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.download}
            onClick={handleOpen}
            disabled={disabled || !fundraisingId}>
            <GetAppIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default DownloadAmbassadorButton;
